export default "__VITE_ASSET__CDkwEdVb__"